<div class="field is-grouped is-grouped-multiline control" [ngStyle]="{'margin-left': FollowsCheckbox ? '20px' : '0px', 'margin-top' : FollowsCheckbox ? '2px': '0px'}">
  @for (x of this.formArray?.value; track x; let i = $index) {
    <div class="tags has-addons">
      <a class="tag">{{x[itemsDisplayProperty]}}</a>
    </div>
  }
  <div class="tags has-addons">
    <a class="tag button is-primary" (click)="AddItem()">Edit</a>
  </div>
</div>